module.exports = __webpack_public_path__ + "static/media/iconfont.dbe527a0.svg";